import { memo } from "react";
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip } from "recharts";
import { kyivTicks, fmtKyivHM } from "@/lib/time";

function CellTip({ active, payload, label, hover, unit, colors }) {
  if (!active || hover == null || !payload || !payload.length) return null;
  const item = payload.find((p) => p.dataKey === `c${hover}`);
  if (!item || item.value == null) return null;
  return (
    <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-md">
      <div className="mb-1 font-mono text-[11px] text-slate-500">{fmtKyivHM(label)}</div>
      <div className="flex items-center gap-2 text-xs">
        <span className="inline-block h-2.5 w-2.5 rounded-full" style={{ background: colors[(hover - 1) % colors.length] }} />
        <span className="font-semibold text-slate-800">Комірка {hover}</span>
        <span className="font-mono font-semibold text-slate-900">
          {item.value} {unit}
        </span>
      </div>
    </div>
  );
}

// Memoized so periodic live-telemetry refreshes don't re-render ~100 SVG lines.
export const CellHistoryChart = memo(function CellHistoryChart({
  points, lines, dayStartMs, xStart, xEnd, hover, onLeave, unit, digits, colors,
}) {
  const ticks = kyivTicks(dayStartMs).filter((t) => t >= xStart && t <= xEnd);
  const axisTick = { fontSize: 10, fontFamily: "JetBrains Mono" };
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={points} margin={{ top: 8, right: 8, bottom: 4, left: -4 }} onMouseLeave={onLeave}>
        <CartesianGrid stroke="#F1F5F9" vertical={false} />
        <XAxis dataKey="t" type="number" domain={[xStart, xEnd]} scale="time" allowDataOverflow
          ticks={ticks} tickFormatter={fmtKyivHM} stroke="#94A3B8" tick={axisTick} />
        <YAxis domain={["auto", "auto"]} stroke="#94A3B8" tick={axisTick} width={52}
          tickFormatter={(v) => v.toFixed(digits)}
          label={{ value: unit, position: "insideTopLeft", fontSize: 10, fill: "#94A3B8" }} />
        <Tooltip content={<CellTip hover={hover} unit={unit} colors={colors} />}
          cursor={{ stroke: "#CBD5E1", strokeDasharray: "3 3" }} isAnimationActive={false} />
        {lines}
      </LineChart>
    </ResponsiveContainer>
  );
});
